export {
  DEFAULT_MODEL,
  DEFAULT_OPENAI_MODEL,
  DEFAULT_ANTHROPIC_MODEL,
} from "./model-config.js";
